<template>
	<div>
		{{ tradable.product__origin }}
		{{
			$cropOptions.getLocalizedLabel(
				tradable.product__grade,
				$cropOptions.productGradeOptions
			)
		}}, {{ __("Harvest") }} {{ tradable.product__harvest }}
	</div>
</template>

<script>
export default {
	props: {
		tradable: {
			type: Object,
			required: true,
		},
	},
};
</script>
